// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament_filter_item .MuiToggleButtonGroup-root{
    display: flex;
    /* grid-template-columns: 35% 35% 35%; */
    border-radius: 4px;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.tournament_filter_item_checkbox{
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space-half);
}

.tournament_filter{
    margin: var(--space) 0;
}

.tournament_filter_item_checkbox_label#Scheduled{
    background-color: #30B36B;
    padding: var(--space-quarter);
    color: var(--white-color);
}
.tournament_filter_item_checkbox_label#Finalized{
    background-color: #4D5451;
    padding: var(--space-quarter);
    color: var(--white-color);
}
.tournament_filter_item_checkbox_label#Registration_Open{
    background-color: #3078B3;
    padding: var(--space-quarter);
    color: var(--white-color);
}

.tournament_item_ubication_city.baloa-username{
    color: var(--white-color);
    font-weight: var(--font-medium);
}

.tournament_item_ubication_city .icon-x{
    color: var(--white-color);
}

.tournament_item_ubication_city .icon-x:hover{
    cursor: pointer;
}

.tournament_item_ubication_city{
    background: #30B36B;
    border: 2px solid #30B36B;
    border-radius: 47px;
    padding: var(--space-half);
    margin: 5px;
    display: flex;
    justify-content: space-between;
}

.tournament_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped{
    border: 0.5px solid #E7E7E7;
    border-radius: 4px;
    padding: 5px 10px;
}

.tournament_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped .MuiToggleButton-label{
    text-transform: capitalize;
}

.tournament_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{
    color: #30B36B !important;
    background: #E6F6EC;
}

.tournament_filter_item_ubication{
    width: 20rem;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tournament_filter_item_ubication .input-field-auto-search {
        margin: 16px 0 0 0;
    }

}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/tournament-filter-state/TournamentFilterItemComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,kBAAkB;IACtB;;AAEJ","sourcesContent":[".tournament_filter_item .MuiToggleButtonGroup-root{\n    display: flex;\n    /* grid-template-columns: 35% 35% 35%; */\n    border-radius: 4px;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n\n.tournament_filter_item_checkbox{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: var(--space-half);\n}\n\n.tournament_filter{\n    margin: var(--space) 0;\n}\n\n.tournament_filter_item_checkbox_label#Scheduled{\n    background-color: #30B36B;\n    padding: var(--space-quarter);\n    color: var(--white-color);\n}\n.tournament_filter_item_checkbox_label#Finalized{\n    background-color: #4D5451;\n    padding: var(--space-quarter);\n    color: var(--white-color);\n}\n.tournament_filter_item_checkbox_label#Registration_Open{\n    background-color: #3078B3;\n    padding: var(--space-quarter);\n    color: var(--white-color);\n}\n\n.tournament_item_ubication_city.baloa-username{\n    color: var(--white-color);\n    font-weight: var(--font-medium);\n}\n\n.tournament_item_ubication_city .icon-x{\n    color: var(--white-color);\n}\n\n.tournament_item_ubication_city .icon-x:hover{\n    cursor: pointer;\n}\n\n.tournament_item_ubication_city{\n    background: #30B36B;\n    border: 2px solid #30B36B;\n    border-radius: 47px;\n    padding: var(--space-half);\n    margin: 5px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped{\n    border: 0.5px solid #E7E7E7;\n    border-radius: 4px;\n    padding: 5px 10px;\n}\n\n.tournament_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped .MuiToggleButton-label{\n    text-transform: capitalize;\n}\n\n.tournament_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{\n    color: #30B36B !important;\n    background: #E6F6EC;\n}\n\n.tournament_filter_item_ubication{\n    width: 20rem;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tournament_filter_item_ubication .input-field-auto-search {\n        margin: 16px 0 0 0;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
